var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.46,
    height: 80.146,
    viewBox: "0 0 66.46 80.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5206",
    "data-name": "Path 5206",
    d: "M15.018-28.149H32.939q11.548,0,17.939,8.076T57.27,2.553q0,13.193-5.754,20.468T35.405,30.3H15.018ZM34.172-39H3.1V41.146H36.638a31.061,31.061,0,0,0,17.282-4.809,31.9,31.9,0,0,0,11.529-13.5A46.981,46.981,0,0,0,69.56,2.553a50.664,50.664,0,0,0-4.419-21.824,34.328,34.328,0,0,0-12.392-14.55A33.339,33.339,0,0,0,34.172-39Z",
    transform: "translate(-3.1 39)",
    fill: "#090b0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.4956a6eda114185c3b569f5f19dd0002.svg";
export { ForwardRef as ReactComponent };